import { faArrowAltDown,faArrowAltLeft,faArrowAltRight,faArrowAltUp,faArrowCircleDown,faArrowCircleUp,faAt,faBan,faBars,faBedAlt,faBell,faBinoculars,faBolt,faBookmark,faCalendar,faChartBar,faChartLine,faCheck,faCheckCircle,faCheckDouble,faCheckSquare,faChevronCircleDown,faChevronDoubleLeft,faChevronDoubleRight,faChevronDown,faChevronLeft,faChevronRight,faChevronUp,faClock,faCloudDownload,faCloudUpload,faCloudsSun,faCoffee,faCog,faCogs,faComment,faCompress,faCopy,faCut,faDatabase,faDotCircle,faEdit,faEllipsisH,faEnvelope,faExchange,faExclamationCircle,faExclamationTriangle,faExpand,faExternalLink,faEye,faEyeSlash,faFileExport,faFileImport,faFilter,faFrown,faGripLines,faGripLinesVertical,faHandHoldingUsd,faHeart,faHistory,faHome,faHotel,faHourglassStart,faImages,faIndent,faInfoCircle,faMap,faMeh,faMinusSquare,faMobile,faMoneyBill,faOutdent,faPaste,faPlus,faPlusSquare,faPrint,faQuestionCircle,faQuoteRight,faRedo,faReply,faSave,faSearch,faShare,faSignIn,faSignInAlt,faSignOut,faSmile,faSort,faSpinnerThird,faSquare,faStar,faStickyNote,faTable,faTimes,faTimesCircle,faTrashAlt,faUndo,faUser,faUserCircle,faUserClock,faUserFriends,faUserPlus,faUserTie,faUserTimes,faUsersClass,faUtensilsAlt } from '@fortawesome/pro-light-svg-icons';

// IMPORTANT!  DO NOT EDIT THIS FILE DIRECTLY!  This file is generated.  Edit the rollup.config.ts in this project instead!
export const FaLightIconDefinitions = {
   ArrowAltDown: faArrowAltDown,
   ArrowAltLeft: faArrowAltLeft,
   ArrowAltRight: faArrowAltRight,
   ArrowAltUp: faArrowAltUp,
   ArrowCircleDown: faArrowCircleDown,
   ArrowCircleUp: faArrowCircleUp,
   At: faAt,
   Ban: faBan,
   Bars: faBars,
   BedAlt: faBedAlt,
   Bell: faBell,
   Binoculars: faBinoculars,
   Bolt: faBolt,
   Bookmark: faBookmark,
   Calendar: faCalendar,
   ChartBar: faChartBar,
   ChartLine: faChartLine,
   Check: faCheck,
   CheckCircle: faCheckCircle,
   CheckDouble: faCheckDouble,
   CheckSquare: faCheckSquare,
   ChevronCircleDown: faChevronCircleDown,
   ChevronDoubleLeft: faChevronDoubleLeft,
   ChevronDoubleRight: faChevronDoubleRight,
   ChevronDown: faChevronDown,
   ChevronLeft: faChevronLeft,
   ChevronRight: faChevronRight,
   ChevronUp: faChevronUp,
   Clock: faClock,
   CloudDownload: faCloudDownload,
   CloudUpload: faCloudUpload,
   CloudsSun: faCloudsSun,
   Coffee: faCoffee,
   Cog: faCog,
   Cogs: faCogs,
   Comment: faComment,
   Compress: faCompress,
   Copy: faCopy,
   Cut: faCut,
   Database: faDatabase,
   DotCircle: faDotCircle,
   Edit: faEdit,
   EllipsisH: faEllipsisH,
   Envelope: faEnvelope,
   Exchange: faExchange,
   ExclamationCircle: faExclamationCircle,
   ExclamationTriangle: faExclamationTriangle,
   Expand: faExpand,
   ExternalLink: faExternalLink,
   Eye: faEye,
   EyeSlash: faEyeSlash,
   FileExport: faFileExport,
   FileImport: faFileImport,
   Filter: faFilter,
   Frown: faFrown,
   GripLines: faGripLines,
   GripLinesVertical: faGripLinesVertical,
   HandHoldingUsd: faHandHoldingUsd,
   Heart: faHeart,
   History: faHistory,
   Home: faHome,
   Hotel: faHotel,
   HourglassStart: faHourglassStart,
   Images: faImages,
   Indent: faIndent,
   InfoCircle: faInfoCircle,
   Map: faMap,
   Meh: faMeh,
   MinusSquare: faMinusSquare,
   Mobile: faMobile,
   MoneyBill: faMoneyBill,
   Outdent: faOutdent,
   Paste: faPaste,
   Plus: faPlus,
   PlusSquare: faPlusSquare,
   Print: faPrint,
   QuestionCircle: faQuestionCircle,
   QuoteRight: faQuoteRight,
   Redo: faRedo,
   Reply: faReply,
   Save: faSave,
   Search: faSearch,
   Share: faShare,
   SignIn: faSignIn,
   SignInAlt: faSignInAlt,
   SignOut: faSignOut,
   Smile: faSmile,
   Sort: faSort,
   SpinnerThird: faSpinnerThird,
   Square: faSquare,
   Star: faStar,
   StickyNote: faStickyNote,
   Table: faTable,
   Times: faTimes,
   TimesCircle: faTimesCircle,
   TrashAlt: faTrashAlt,
   Undo: faUndo,
   User: faUser,
   UserCircle: faUserCircle,
   UserClock: faUserClock,
   UserFriends: faUserFriends,
   UserPlus: faUserPlus,
   UserTie: faUserTie,
   UserTimes: faUserTimes,
   UsersClass: faUsersClass,
   UtensilsAlt: faUtensilsAlt,
};
